import React from 'react'

import { type OutputType } from '~/gql/graphql'

import { type GroupDefinitionMap } from '../utils'

type CommentGenerationContextValue = {
  groupDefinitionMap: GroupDefinitionMap
  outputType: OutputType
  surveyId: string
}

const CommentGenerationContext =
  React.createContext<CommentGenerationContextValue | null>(null)

export type CommentGenerationProviderProps = React.PropsWithChildren<{
  groupDefinitionMap: GroupDefinitionMap
  outputType: OutputType
  surveyId: string
}>

export const CommentGenerationProvider = ({
  children,
  groupDefinitionMap,
  outputType,
  surveyId,
}: CommentGenerationProviderProps) => (
  <CommentGenerationContext.Provider
    value={React.useMemo(
      () => ({ groupDefinitionMap, outputType, surveyId }),
      [groupDefinitionMap, outputType, surveyId],
    )}
  >
    {children}
  </CommentGenerationContext.Provider>
)

export const useCommentGenerationContext = () => {
  const context = React.useContext(CommentGenerationContext)
  if (context === null) {
    throw new Error(
      'useCommentGenerationContext must be used within a CommentGenerationProvider',
    )
  }

  return context
}
